import React, { useRef } from 'react';

import BackToTop from 'Components/shared/BackToTop/BackToTop';
import { triggerBackToTopClickedEvent } from 'Services/analytics/events';
import proPropTypes from 'Utilities/proPropTypes';

import styles from './VehiclesListBackToTop.module.scss';

const VehiclesListBackToTop = React.memo(({ focusRef }) => {
	const anchorRef = useRef();

	return (
		<>
			<div ref={anchorRef} className={styles.anchor} />
			<BackToTop
				anchorRef={anchorRef}
				buttonClassName={styles.button}
				className={styles.backToTop}
				focusRef={focusRef}
				onClick={triggerBackToTopClickedEvent}
			/>
		</>
	);
});

VehiclesListBackToTop.propTypes = {
	focusRef: proPropTypes.forwardedRef.isRequired,
};

export default VehiclesListBackToTop;
